/**
 * Module-level flag synced from AdFreeSubscriberContext.
 * Plain TS modules (e.g. adMobService) cannot use React context.
 *
 * The app has no in-app purchases. Ad-free status is granted manually by an
 * admin (`users.ad_free_manual`); ebooks unlock by watching a rewarded ad.
 */
let adFreeManual = false;

export function setAdFreeManualSubscriber(value: boolean): void {
  adFreeManual = value;
}

export function getAdFreeManualSubscriber(): boolean {
  return adFreeManual;
}

/** Admin-approved ad-free. */
export function getPremiumSubscriber(): boolean {
  return adFreeManual;
}
